import { useEffect, useState } from 'react';

import { MESSAGE_STATE_ERROR } from 'constants/message-app-state-contants';
import AppPage from 'layouts/AppPage/AppPage';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { EmailVerificationAlert } from './components/EmailVerificationAlert/EmailVerificationAlert';
import { TwoFactorAuthenticationEnforcementModal } from './components/TwoFactorAuthenticationEnforcementModal/TwoFactorAuthenticationEnforcementModal';

import { messagePopUp } from 'api/app-slice';
import { logout } from 'api/authentication-slice';
import { resendUserEmailValidation, selectUser } from 'api/user-slice';

const AccountValidation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector(selectUser);

  const [loading, setLoading] = useState(false);
  const { target } = useParams();

  const [verificationAlert, setVerificationAlert] = useState(false);
  const [emailVerificationSent, setEmailVerificationSent] = useState(false);

  const [twoFactorAuthenticationEnforcementModal, setTwoFactorAuthenticationEnforcementModal] =
    useState(false);

  useEffect(() => {
    switch (target) {
      case 'email':
        if (user.verified) {
          redirectToDashboard();
        } else {
          setVerificationAlert(true);
        }
        break;
      case '2fa':
        if (user.two_factor_auth_enabled) {
          redirectToDashboard();
        } else {
          setTwoFactorAuthenticationEnforcementModal(true);
        }
        break;
      default:
        break;
    }
  }, [target]);

  const signOut = async () => {
    await dispatch(logout());
    navigate('/sign_in');
  };

  const resendEmail = async () => {
    setLoading(true);
    dispatch(
      messagePopUp({
        text: 'Please validate your email address.',
        state: MESSAGE_STATE_ERROR,
        hide: false,
      }),
    );
    if (!user.verified) {
      await dispatch(resendUserEmailValidation(user.id));
      setEmailVerificationSent(true);
    }
    setLoading(false);
  };

  const redirectToDashboard = () => {
    navigate('/dashboard');
  };

  return (
    <AppPage loading={loading} hideNavigation={true}>
      <EmailVerificationAlert
        visble={verificationAlert}
        resend={resendEmail}
        sent={emailVerificationSent}
        onSignOut={signOut}
      />
      <TwoFactorAuthenticationEnforcementModal
        user={user}
        visble={twoFactorAuthenticationEnforcementModal}
        setLoading={setLoading}
        onSuccess={redirectToDashboard}
      />
    </AppPage>
  );
};

export default AccountValidation;
